import { JSX } from "solid-js/jsx-runtime";

export const CloseIcon = (props: JSX.SvgSVGAttributes<SVGSVGElement>) => (
  <svg
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_515_997)">
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke={props.color || "#171717"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke={props.color || "#171717"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_515_997">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
